export default "__VITE_ASSET__C7th6Ghq__"